import React, { useState, useEffect } from 'react';
import { Post } from '../Post/post';
import UserApi from 'apis/UserApi';

export function FeedsModal({ isOpen, onClose, base_URL }) {
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    search: '',
   
  });

  const fetchFeeds = async () => {
    setLoading(true);
    try {
      const response = await UserApi.getAllFeeds();
      setFeeds(response?.data?.data || []);
      setTotalPages(Math.ceil((response?.data?.data || []).length / 9)); // 9 items per page
    } catch (error) {
      console.error("Error fetching feeds:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchFeeds();
    }
  }, [isOpen]);

  const filteredFeeds = feeds.filter(feed => {
    if (!filters.search) return true;
    
    const searchTerm = filters.search.toLowerCase();
    return (
      feed.title?.toLowerCase().includes(searchTerm) ||
      feed.description?.toLowerCase().includes(searchTerm) ||
      feed.place?.toLowerCase().includes(searchTerm)
    );
  });

  const paginatedFeeds = filteredFeeds.slice((currentPage - 1) * 9, currentPage * 9);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setCurrentPage(1); // Reset to first page when filters change
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-2xl font-bold text-gray-900">All Feeds</h3>
                  <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <i className="fas fa-times text-xl"></i>
                  </button>
                </div>

                {/* Filters */}
               
                <div className="bg-gray-50 rounded-xl p-6 mb-8">
                  <div className="flex flex-col md:flex-row items-center gap-6">
                    <div className="w-full md:w-1/3">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Search Feeds
                      </label>
                      <div className="relative w-full">
                        <input
                          type="text"
                          name="search"
                          value={filters.search}
                          onChange={handleFilterChange}
                          className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-all duration-200 placeholder-gray-400 bg-white shadow-sm"
                          placeholder="Search by title, description, or place..."
                        />
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <i className="fas fa-search text-gray-400"></i>
                        </div>
                      </div>
                      <p className="mt-1.5 text-xs text-gray-500">
                        Enter keywords to filter feeds
                      </p>
                    </div>
                  </div>
                </div>

                {/* Feeds Grid */}
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6">
                  {loading ? (
                    [...Array(6)].map((_, index) => (
                      <div key={index} className="animate-pulse">
                        <div className="bg-gray-200 rounded-lg h-48 mb-4"></div>
                        <div className="bg-gray-200 rounded h-4 w-3/4 mb-2"></div>
                        <div className="bg-gray-200 rounded h-4 w-1/2"></div>
                      </div>
                    ))
                  ) : paginatedFeeds.length > 0 ? (
                    paginatedFeeds.map((feed) => (
                      <Post
                        key={feed.id}
                        id={feed.id}
                        title={feed.title}
                        description={feed.description}
                        imageUrl={feed.media_url?.[0] ? `${base_URL}/get-image?objectKey=${feed.media_url[0]}` : '/placeholder.jpg'}
                        date={new Date(feed.date_conducted).toLocaleDateString()}
                        location={feed.place}
                        likes={0}
                        comments={0}
                        shares={0}
                        author={{
                          name: "Alumni Association",
                          avatar: '/avatar.jpg',
                        }}
                        badge={{
                          text: feed.feed_type?.charAt(0).toUpperCase() + feed.feed_type?.slice(1) || 'Meetup',
                          color: feed.feed_type === 'meetup' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' :
                                 feed.feed_type === 'information' ? 'bg-blue-50 text-blue-600' :
                                 'bg-green-50 text-green-600'
                        }}
                      />
                    ))
                  ) : (
                    <div className="col-span-full text-center py-12">
                      <p className="text-gray-500 text-lg">No feeds found matching your filters.</p>
                    </div>
                  )}
                </div>

                {/* Pagination */}
                {!loading && filteredFeeds.length > 0 && (
                  <div className="flex justify-center items-center mt-8 space-x-2">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Previous
                    </button>
                    <span className="px-4 py-2 text-sm font-medium text-gray-700">
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}